import { useComputed, useSignal } from '@preact/signals-react';

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import ListGroup from "react-bootstrap/ListGroup";
import Modal from 'react-bootstrap/Modal';
import { Badge, Col, Row } from 'react-bootstrap';

import Icon from "../../../components/Icon";
import { removeDeviceListFilter } from '../../../state/actions/userSettingsActions';
import { deviceListFiltersValueSignal } from '../../../state/signals/userSettingsSignals';
function DevicesListFilteringModal({ show, handleCancel, handleSubmit }) {

    const defaultDateComputed = useComputed(() => {
        const currentDate = new Date()
        const pastThirtyDay = new Date(currentDate)
        pastThirtyDay.setDate(currentDate.getDate() - 30) // Subtract 30 days to give results within the last month
        pastThirtyDay.setHours(0, 0, 0, 0) // Set time to midnight
        return pastThirtyDay;
    })

    const currentSelectedFilterSignal = useSignal("UtgVersion")
    const handleSelectFilter = (selectedFilter) => {
        currentSelectedFilterSignal.value = selectedFilter
    }
    
    const retrievePreviousFilterValue = (field, property) => {
        
        if (!deviceListFiltersValueSignal.value) {
            return ""
        }

        const predicates = deviceListFiltersValueSignal.value.Predicates
        let match = []
        let isMultiplePredicates = false
        let multiplePredicatesOperator = "AND"

        for (let predicate of predicates) {
            // If single predicate
            if (predicate.PropertyName === field) {
                match.push(predicate)
                break
            }

            // If multiple predicates
            if (Array.isArray(predicate.Value)) {
                multiplePredicatesOperator = predicate.Operator
                const nestedMatch = predicate.Value.filter(p => p.PropertyName === field)
                if (nestedMatch.length > 0) {
                    match = nestedMatch
                    isMultiplePredicates = true
                    break
                }
            }
        }

        if (match) {
            switch (property) {
                case "value":
                    return match.length > 0 ? match[0].Value : ""
                case "operator":
                    return match.length > 0 ? match[0].Operator : ""
                case "multiplePredicates":
                    return isMultiplePredicates
                case "multiplePredicatesOperator":
                    return multiplePredicatesOperator
                case "additionalPredicateValue":
                    return match.length > 1 ? match[1].Value : ""
                case "additionalPredicateOperator":
                    return match.length > 1 ? match[1].Operator : ""
                default:
                    return ""
            }
        }
        return ""
    }

    const utgVersionTextSignal = useSignal(retrievePreviousFilterValue("UtgVersion", "value"))
    const utgVersionOperatorSignal = useSignal(retrievePreviousFilterValue("UtgVersion", "operator") === "" ? "LIKE" : retrievePreviousFilterValue("UtgVersion", "operator"))
    const utgVersionMultiplePredicatesSignal = useSignal(retrievePreviousFilterValue("UtgVersion", "multiplePredicates"))
    const utgVersionMultiplePredicatesOperatorSignal = useSignal(retrievePreviousFilterValue("UtgVersion", "multiplePredicatesOperator"))
    const utgVersionAdditionalPredicateTextSignal = useSignal(retrievePreviousFilterValue("UtgVersion", "additionalPredicateValue"))
    const utgVersionAdditionalPredicateOperatorSignal = useSignal(retrievePreviousFilterValue("UtgVersion", "additionalPredicateOperator") === "" ? "LIKE" : retrievePreviousFilterValue("UtgVersion", "additionalOperator"))

    const agentVersionTextSignal = useSignal(retrievePreviousFilterValue("AgentVersion", "value"))
    const agentVersionOperatorSignal = useSignal(retrievePreviousFilterValue("AgentVersion", "operator") === "" ? "LIKE" : retrievePreviousFilterValue("AgentVersion", "operator"))
    const agentVersionMultiplePredicatesSignal = useSignal(retrievePreviousFilterValue("AgentVersion", "multiplePredicates"))
    const agentVersionMultiplePredicatesOperatorSignal = useSignal(retrievePreviousFilterValue("AgentVersion", "multiplePredicatesOperator"))
    const agentVersionAdditionalPredicateTextSignal = useSignal(retrievePreviousFilterValue("AgentVersion", "additionalPredicateValue"))
    const agentVersionAdditionalPredicateOperatorSignal = useSignal(retrievePreviousFilterValue("AgentVersion", "additionalPredicateOperator") === "" ? "LIKE" : retrievePreviousFilterValue("AgentVersion", "additionalPredicateOperator"))

    const merchantTextSignal = useSignal(retrievePreviousFilterValue("ComponentMerchant", "value"))
    const utgNicknameTextSignal = useSignal(retrievePreviousFilterValue("ComponentNickname", "value"))
    const profileTextSignal = useSignal(retrievePreviousFilterValue("ComponentProfileName", "value"))
    const profileVersionIntegerSignal = useSignal(retrievePreviousFilterValue("ComponentProfileVersion", "value") === "" ? 0 : retrievePreviousFilterValue("ComponentProfileVersion", "value"))
    const locationTextSignal = useSignal(retrievePreviousFilterValue("ComponentLocation", "value"))
    const laneTextSignal = useSignal(retrievePreviousFilterValue("ComponentLane", "value"))
    const fileIdTextSignal = useSignal(retrievePreviousFilterValue("ComponentFileId", "value"))
    const machineStatusTextSignal = useSignal(retrievePreviousFilterValue("MachineStatus", "value"))
    const utgStatusTextSignal = useSignal(retrievePreviousFilterValue("UtgStatus", "value"))

    const firmwareVersionTextSignal = useSignal(retrievePreviousFilterValue("DeviceStatusFirmwareVersion", "value"))
    const firmwareVersionOperatorSignal = useSignal(retrievePreviousFilterValue("DeviceStatusFirmwareVersion", "operator") === "" ? "LIKE" : retrievePreviousFilterValue("DeviceStatusFirmwareVersion", "operator"))
    const firmwareVersionMultiplePredicatesSignal = useSignal(retrievePreviousFilterValue("DeviceStatusFirmwareVersion", "multiplePredicates"))
    const firmwareVersionMultiplePredicatesOperatorSignal = useSignal(retrievePreviousFilterValue("DeviceStatusFirmwareVersion", "multiplePredicatesOperator"))
    const firmwareVersionAdditionalPredicateTextSignal = useSignal(retrievePreviousFilterValue("DeviceStatusFirmwareVersion", "additionalPredicateValue"))
    const firmwareVersionAdditionalPredicateOperatorSignal = useSignal(retrievePreviousFilterValue("DeviceStatusFirmwareVersion", "additionalPredicateOperator") === "" ? "LIKE" : retrievePreviousFilterValue("DeviceStatusFirmwareVersion", "additionalPredicateOperator"))

    const pciVersionTextSignal = useSignal(retrievePreviousFilterValue("DeviceStatusDevicePciVersion", "value"))
    const pciVersionOperatorSignal = useSignal(retrievePreviousFilterValue("DeviceStatusDevicePciVersion", "operator") === "" ? "LIKE" : retrievePreviousFilterValue("DeviceStatusDevicePciVersion", "operator"))
    const pciVersionMultiplePredicatesSignal = useSignal(retrievePreviousFilterValue("DeviceStatusDevicePciVersion", "multiplePredicates"))
    const pciVersionMultiplePredicatesOperatorSignal = useSignal(retrievePreviousFilterValue("DeviceStatusDevicePciVersion", "multiplePredicatesOperator"))
    const pciVersionAdditionalPredicateTextSignal = useSignal(retrievePreviousFilterValue("DeviceStatusDevicePciVersion", "additionalPredicateValue"))
    const pciVersionAdditionalPredicateOperatorSignal = useSignal(retrievePreviousFilterValue("DeviceStatusDevicePciVersion", "additionalPredicateOperator") === "" ? "LIKE" : retrievePreviousFilterValue("DeviceStatusDevicePciVersion", "additionalPredicateOperator"))

    const deviceTypeTextSignal = useSignal(retrievePreviousFilterValue("DeviceConfigDeviceType", "value"))
    const deviceSerialTextSignal = useSignal(retrievePreviousFilterValue("DeviceStatusDeviceSerialNumber", "value"))
    const terminalIdTextSignal = useSignal(retrievePreviousFilterValue("DeviceConfigApiTerminalId", "value"))

    const componentPermanentIdTextSignal = useSignal(retrievePreviousFilterValue("ComponentPermanentId", "value"))
    const machinePermanentIdTextSignal = useSignal(retrievePreviousFilterValue("MachinePermanentId", "value"))
    const machinePermanentIdErrorSignal = useSignal(false)
    const componentPermanentIdErrorSignal = useSignal(false)

    const standardTimeZoneTextSignal = useSignal(retrievePreviousFilterValue("MachineStatusEntityStandardTimeZone", "value"))

    const isValidGuid = (str) => /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(str)

    const handleBuildPredicatesObject = () => {
        const predicates = {
            "Predicates": []
        }
        if (utgVersionTextSignal.value != "") {
            const predicate = {}
            if (utgVersionMultiplePredicatesSignal.value && utgVersionAdditionalPredicateTextSignal.value != "") {
                predicate.Operator = utgVersionMultiplePredicatesOperatorSignal.value
                predicate.Value = []
                predicate.Value.push({
                    PropertyName: "UtgVersion",
                    Operator: utgVersionOperatorSignal.value,
                    Value: utgVersionTextSignal.value,
                    TypeHint: "Version"
                })
                predicate.Value.push({
                    PropertyName: "UtgVersion",
                    Operator: utgVersionAdditionalPredicateOperatorSignal.value,
                    Value: utgVersionAdditionalPredicateTextSignal.value,
                    TypeHint: "Version"
                })
                predicates.Predicates.push(predicate)
            } else {
                predicates.Predicates.push({
                    PropertyName: "UtgVersion",
                    Operator: utgVersionOperatorSignal.value,
                    Value: utgVersionTextSignal.value,
                    TypeHint: "Version"
                })
            }
        }
        if (agentVersionTextSignal.value != "") {
            const predicate = {}
            if (agentVersionMultiplePredicatesSignal.value && agentVersionAdditionalPredicateTextSignal.value != "") {
                predicate.Operator = agentVersionMultiplePredicatesOperatorSignal.value
                predicate.Value = []
                predicate.Value.push({
                    PropertyName: "AgentVersion",
                    Operator: agentVersionOperatorSignal.value,
                    Value: agentVersionTextSignal.value,
                    TypeHint: "Version"
                })
                predicate.Value.push({
                    PropertyName: "AgentVersion",
                    Operator: agentVersionAdditionalPredicateOperatorSignal.value,
                    Value: agentVersionAdditionalPredicateTextSignal.value,
                    TypeHint: "Version"
                })
                predicates.Predicates.push(predicate)
            } else {
                predicates.Predicates.push({
                    PropertyName: "AgentVersion",
                    Operator: agentVersionOperatorSignal.value,
                    Value: agentVersionTextSignal.value,
                    TypeHint: "Version"
                })
            }
        }
        if (merchantTextSignal.value != "") {
            const predicate = {}
            predicate.PropertyName = "ComponentMerchant"
            predicate.Operator = "LIKE"
            predicate.Value = merchantTextSignal.value
            predicates.Predicates.push(predicate)
        }
        if (utgNicknameTextSignal.value != "") {
            const predicate = {}
            predicate.PropertyName = "ComponentNickname"
            predicate.Operator = "LIKE"
            predicate.Value = utgNicknameTextSignal.value
            predicates.Predicates.push(predicate)
        }
        if (profileTextSignal.value != "") {
            const predicate = {}
            predicate.PropertyName = "ComponentProfileName"
            predicate.Operator = "LIKE"
            predicate.Value = profileTextSignal.value
            predicates.Predicates.push(predicate)
        }
        if (profileVersionIntegerSignal.value != 0) {
            const predicate = {}
            predicate.PropertyName = "ComponentProfileVersion"
            predicate.Operator = "EQ"
            predicate.Value = profileVersionIntegerSignal.value
            predicate.TypeHint = "Integer"
            predicates.Predicates.push(predicate)
        }
        if (locationTextSignal.value != "") {
            const predicate = {}
            predicate.PropertyName = "ComponentLocation"
            predicate.Operator = "LIKE"
            predicate.Value = locationTextSignal.value
            predicates.Predicates.push(predicate)
        }
        if (laneTextSignal.value != "") {
            const predicate = {}
            predicate.PropertyName = "ComponentLane"
            predicate.Operator = "LIKE"
            predicate.Value = laneTextSignal.value
            predicates.Predicates.push(predicate)
        }
        if (fileIdTextSignal.value != "") {
            const predicate = {}
            predicate.PropertyName = "ComponentFileId"
            predicate.Operator = "LIKE"
            predicate.Value = fileIdTextSignal.value
            predicates.Predicates.push(predicate)
        }
        if (machineStatusTextSignal.value != "") {
            const predicate = {}
            predicate.PropertyName = "MachineStatus"
            predicate.Operator = "LIKE"
            predicate.Value = machineStatusTextSignal.value
            predicates.Predicates.push(predicate)
        }
        if (utgStatusTextSignal.value != "") {
            const predicate = {}
            predicate.PropertyName = "UtgStatus"
            predicate.Operator = "LIKE"
            predicate.Value = utgStatusTextSignal.value
            predicates.Predicates.push(predicate)
        }
        if (firmwareVersionTextSignal.value != "") {
            const predicate = {}
            if (firmwareVersionMultiplePredicatesSignal.value && firmwareVersionAdditionalPredicateTextSignal.value != "") {
                predicate.Operator = firmwareVersionMultiplePredicatesOperatorSignal.value
                predicate.Value = []
                predicate.Value.push({
                    PropertyName: "DeviceStatusFirmwareVersion",
                    Operator: firmwareVersionOperatorSignal.value,
                    Value: firmwareVersionTextSignal.value,
                    TypeHint: "Version"
                })
                predicate.Value.push({
                    PropertyName: "DeviceStatusFirmwareVersion",
                    Operator: firmwareVersionAdditionalPredicateOperatorSignal.value,
                    Value: firmwareVersionAdditionalPredicateTextSignal.value,
                    TypeHint: "Version"
                })
                predicates.Predicates.push(predicate)
            } else {
                predicates.Predicates.push({
                    PropertyName: "DeviceStatusFirmwareVersion",
                    Operator: firmwareVersionOperatorSignal.value,
                    Value: firmwareVersionTextSignal.value,
                    TypeHint: "Version"
                })
            }
        }
        if (pciVersionTextSignal.value != "") {
            const predicate = {}
            if (pciVersionMultiplePredicatesSignal.value && pciVersionAdditionalPredicateTextSignal.value != "") {
                predicate.Operator = pciVersionMultiplePredicatesOperatorSignal.value
                predicate.Value = []
                predicate.Value.push({
                    PropertyName: "DeviceStatusDevicePciVersion",
                    Operator: pciVersionOperatorSignal.value,
                    Value: pciVersionTextSignal.value,
                    TypeHint: "Version"
                })
                predicate.Value.push({
                    PropertyName: "DeviceStatusDevicePciVersion",
                    Operator: pciVersionAdditionalPredicateOperatorSignal.value,
                    Value: pciVersionAdditionalPredicateTextSignal.value,
                    TypeHint: "Version"
                })
                predicates.Predicates.push(predicate)
            } else {
                predicates.Predicates.push({
                    PropertyName: "DeviceStatusDevicePciVersion",
                    Operator: pciVersionOperatorSignal.value,
                    Value: pciVersionTextSignal.value,
                    TypeHint: "Version"
                })
            }
        }
        if (deviceTypeTextSignal.value != "") {
            const predicate = {}
            predicate.PropertyName = "DeviceConfigDeviceType"
            predicate.Operator = "LIKE"
            predicate.Value = deviceTypeTextSignal.value
            predicates.Predicates.push(predicate)
        }
        if (deviceSerialTextSignal.value != "") {
            const predicate = {}
            predicate.PropertyName = "DeviceStatusDeviceSerialNumber"
            predicate.Operator = "LIKE"
            predicate.Value = deviceSerialTextSignal.value
            predicates.Predicates.push(predicate)
        }
        if (terminalIdTextSignal.value != "") {
            const predicate = {}
            predicate.PropertyName = "DeviceConfigApiTerminalId"
            predicate.Operator = "LIKE"
            predicate.Value = terminalIdTextSignal.value
            predicates.Predicates.push(predicate)
        }
        if (componentPermanentIdTextSignal.value != "") {
            const predicate = {}
            predicate.PropertyName = "ComponentPermanentId"
            predicate.Operator = "EQ"
            predicate.Value = componentPermanentIdTextSignal.value
            predicate.TypeHint = "Guid"
            predicates.Predicates.push(predicate)
        }
        if (machinePermanentIdTextSignal.value != "") {
            const predicate = {}
            predicate.PropertyName = "MachinePermanentId"
            predicate.Operator = "EQ"
            predicate.Value = machinePermanentIdTextSignal.value
            predicate.TypeHint = "Guid"
            predicates.Predicates.push(predicate)
        }
        if (standardTimeZoneTextSignal.value != "") {
            const predicate = {}
            predicate.PropertyName = "MachineStatusEntityStandardTimeZone"
            predicate.Operator = "LIKE"
            predicate.Value = standardTimeZoneTextSignal.value
            predicates.Predicates.push(predicate)
        }

        // After Predicates Array is built, call the handleSubmit from UTG List page to actually apply filters to data
        handleSubmit(predicates)
    }

    const handleResetFilters = () => {
        removeDeviceListFilter()

        utgVersionTextSignal.value = ""
        utgVersionOperatorSignal.value = "LIKE"
        utgVersionMultiplePredicatesSignal.value = false
        utgVersionMultiplePredicatesOperatorSignal.value = "AND"
        utgVersionAdditionalPredicateTextSignal.value = ""
        utgVersionAdditionalPredicateOperatorSignal.value = "LIKE"

        agentVersionTextSignal.value = ""
        agentVersionOperatorSignal.value = "LIKE"
        agentVersionMultiplePredicatesSignal.value = false
        agentVersionMultiplePredicatesOperatorSignal.value = "AND"
        agentVersionAdditionalPredicateTextSignal.value = ""
        agentVersionAdditionalPredicateOperatorSignal.value = "LIKE"

        merchantTextSignal.value = ""
        utgNicknameTextSignal.value = ""
        profileTextSignal.value = ""
        profileVersionIntegerSignal.value = 0
        locationTextSignal.value = ""
        laneTextSignal.value = ""
        fileIdTextSignal.value = ""
        machineStatusTextSignal.value = ""
        utgStatusTextSignal.value = ""

        firmwareVersionTextSignal.value = ""
        firmwareVersionOperatorSignal.value = "LIKE"
        firmwareVersionMultiplePredicatesSignal.value = false
        firmwareVersionMultiplePredicatesOperatorSignal.value = "AND"
        firmwareVersionAdditionalPredicateTextSignal.value = ""
        firmwareVersionAdditionalPredicateOperatorSignal.value = "LIKE"

        pciVersionTextSignal.value = ""
        pciVersionOperatorSignal.value = "LIKE"
        pciVersionMultiplePredicatesSignal.value = false
        pciVersionMultiplePredicatesOperatorSignal.value = "AND"
        pciVersionAdditionalPredicateTextSignal.value = ""
        pciVersionAdditionalPredicateOperatorSignal.value = "LIKE"

        deviceTypeTextSignal.value = ""
        deviceSerialTextSignal.value = ""
        terminalIdTextSignal.value = ""

        componentPermanentIdTextSignal.value = ""
        machinePermanentIdTextSignal.value = ""

        standardTimeZoneTextSignal.value = ""
    }

    return (
        <Modal
            show={show}
            onHide={handleCancel}
            backdrop="static"
            keyboard={false}
            size='lg'
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>Filters</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col xs={5}>
                        <ListGroup as="ul">
                            <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start" onClick={() => handleSelectFilter("UtgVersion")} active={currentSelectedFilterSignal.value === "UtgVersion"}>
                                <div className="ms-2 me-auto">UTG Version</div>
                                {!!utgVersionTextSignal.value.length && (<Badge bg="light" text="dark" pill>Active</Badge>)}
                            </ListGroup.Item>

                            <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start" onClick={() => handleSelectFilter("AgentVersion")} active={currentSelectedFilterSignal.value === "AgentVersion"}>
                                <div className="ms-2 me-auto">Agent Version</div>
                                {!!agentVersionTextSignal.value.length && (<Badge bg="light" text="dark" pill>Active</Badge>)}
                            </ListGroup.Item>

                            <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start" onClick={() => handleSelectFilter("ComponentMerchant")} active={currentSelectedFilterSignal.value === "ComponentMerchant"}>
                                <div className="ms-2 me-auto">Merchant</div>
                                {!!merchantTextSignal.value.length && (<Badge bg="light" text="dark" pill>Active</Badge>)}
                            </ListGroup.Item>

                            <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start" onClick={() => handleSelectFilter("ComponentNickname")} active={currentSelectedFilterSignal.value === "ComponentNickname"}>
                                <div className="ms-2 me-auto">UTG Nickname</div>
                                {!!utgNicknameTextSignal.value.length && (<Badge bg="light" text="dark" pill>Active</Badge>)}
                            </ListGroup.Item>

                            <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start" onClick={() => handleSelectFilter("ComponentProfileName")} active={currentSelectedFilterSignal.value === "ComponentProfileName"}>
                                <div className="ms-2 me-auto">Profile</div>
                                {!!profileTextSignal.value.length && (<Badge bg="light" text="dark" pill>Active</Badge>)}
                            </ListGroup.Item>

                            <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start" onClick={() => handleSelectFilter("ComponentProfileVersion")} active={currentSelectedFilterSignal.value === "ComponentProfileVersion"}>
                                <div className="ms-2 me-auto">Profile Version</div>
                                {profileVersionIntegerSignal.value !== 0 && (<Badge bg="light" text="dark" pill>Active</Badge>)}
                            </ListGroup.Item>

                            <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start" onClick={() => handleSelectFilter("ComponentLocation")} active={currentSelectedFilterSignal.value === "ComponentLocation"}>
                                <div className="ms-2 me-auto">Location/Serial</div>
                                {!!locationTextSignal.value.length && (<Badge bg="light" text="dark" pill>Active</Badge>)}
                            </ListGroup.Item>

                            <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start" onClick={() => handleSelectFilter("ComponentLane")} active={currentSelectedFilterSignal.value === "ComponentLane"}>
                                <div className="ms-2 me-auto">Lane</div>
                                {!!laneTextSignal.value.length && (<Badge bg="light" text="dark" pill>Active</Badge>)}
                            </ListGroup.Item>

                            <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start" onClick={() => handleSelectFilter("ComponentFileId")} active={currentSelectedFilterSignal.value === "ComponentFileId"}>
                                <div className="ms-2 me-auto">File ID</div>
                                {!!fileIdTextSignal.value.length && (<Badge bg="light" text="dark" pill>Active</Badge>)}
                            </ListGroup.Item>

                            <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start" onClick={() => handleSelectFilter("MachineStatus")} active={currentSelectedFilterSignal.value === "MachineStatus"}>
                                <div className="ms-2 me-auto">Machine Status</div>
                                {!!machineStatusTextSignal.value.length && (<Badge bg="light" text="dark" pill>Active</Badge>)}
                            </ListGroup.Item>

                            <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start" onClick={() => handleSelectFilter("UtgStatus")} active={currentSelectedFilterSignal.value === "UtgStatus"}>
                                <div className="ms-2 me-auto">UTG Status</div>
                                {!!utgStatusTextSignal.value.length && (<Badge bg="light" text="dark" pill>Active</Badge>)}
                            </ListGroup.Item>

                            <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start" onClick={() => handleSelectFilter("DeviceStatusFirmwareVersion")} active={currentSelectedFilterSignal.value === "DeviceStatusFirmwareVersion"}>
                                <div className="ms-2 me-auto">Firmware Version</div>
                                {!!firmwareVersionTextSignal.value.length && (<Badge bg="light" text="dark" pill>Active</Badge>)}
                            </ListGroup.Item>

                            <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start" onClick={() => handleSelectFilter("DeviceStatusDevicePciVersion")} active={currentSelectedFilterSignal.value === "DeviceStatusDevicePciVersion"}>
                                <div className="ms-2 me-auto">PCI Version</div>
                                {!!pciVersionTextSignal.value.length && (<Badge bg="light" text="dark" pill>Active</Badge>)}
                            </ListGroup.Item>

                            <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start" onClick={() => handleSelectFilter("DeviceConfigDeviceType")} active={currentSelectedFilterSignal.value === "DeviceConfigDeviceType"}>
                                <div className="ms-2 me-auto">Device Type</div>
                                {!!deviceTypeTextSignal.value.length && (<Badge bg="light" text="dark" pill>Active</Badge>)}
                            </ListGroup.Item>

                            <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start" onClick={() => handleSelectFilter("DeviceStatusDeviceSerialNumber")} active={currentSelectedFilterSignal.value === "DeviceStatusDeviceSerialNumber"}>
                                <div className="ms-2 me-auto">Device Serial</div>
                                {!!deviceSerialTextSignal.value.length && (<Badge bg="light" text="dark" pill>Active</Badge>)}
                            </ListGroup.Item>

                            <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start" onClick={() => handleSelectFilter("DeviceConfigApiTerminalId")} active={currentSelectedFilterSignal.value === "DeviceConfigApiTerminalId"}>
                                <div className="ms-2 me-auto">Terminal ID</div>
                                {!!terminalIdTextSignal.value.length && (<Badge bg="light" text="dark" pill>Active</Badge>)}
                            </ListGroup.Item>

                            <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start" onClick={() => handleSelectFilter("ComponentPermanentId")} active={currentSelectedFilterSignal.value === "ComponentPermanentId"}>
                                <div className="ms-2 me-auto">Component Permanent ID</div>
                                {!!componentPermanentIdTextSignal.value.length && (<Badge bg="light" text="dark" pill>Active</Badge>)}
                            </ListGroup.Item>

                            <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start" onClick={() => handleSelectFilter("MachinePermanentId")} active={currentSelectedFilterSignal.value === "MachinePermanentId"}>
                                <div className="ms-2 me-auto">Machine Permanent ID</div>
                                {!!machinePermanentIdTextSignal.value.length && (<Badge bg="light" text="dark" pill>Active</Badge>)}
                            </ListGroup.Item>
                            
                            <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start" onClick={() => handleSelectFilter("StandardTimeZone")} active={currentSelectedFilterSignal.value === "StandardTimeZone"}>
                                <div className="ms-2 me-auto">Time Zone</div>
                                {!!standardTimeZoneTextSignal.value.length && (<Badge bg="light" text="dark" pill>Active</Badge>)}
                            </ListGroup.Item>

                        </ListGroup>
                    </Col>
                    <Col>
                        <Form onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}>
                            {/* UTG Version Filter */}
                            {(currentSelectedFilterSignal.value === "UtgVersion" && (
                                <Form.Group className="mb-3" controlId="utgVersion">
                                    <Form.Label className="d-block">Utg Version</Form.Label>
                                    <Form.Select className="mb-3" onInput={(e) => utgVersionOperatorSignal.value = e.target.value} value={utgVersionOperatorSignal.value == null ? "LIKE" : utgVersionOperatorSignal.value}>
                                        <option value="LIKE">Is Equal To</option>
                                        <option value="NEQ">Is Not Equal To</option>
                                        <option value="LT">Is Less Than</option>
                                        <option value="LTE">Is Less Than or Equal To</option>
                                        <option value="GT">Is Greater Than</option>
                                        <option value="GTE">Is Greater Than or Equal To</option>
                                    </Form.Select>
                                    <Form.Control type="text" className="d-block mb-3" onChange={(event) => utgVersionTextSignal.value = event.target.value} value={utgVersionTextSignal.value} />
                                    <Button onClick={() => utgVersionMultiplePredicatesSignal.value = true} hidden={utgVersionMultiplePredicatesSignal.value}>Add Condition</Button>
                                </Form.Group>
                            ))}

                            {/* UTG Version Filter Additional Condition */}
                            {(currentSelectedFilterSignal.value === "UtgVersion" && utgVersionMultiplePredicatesSignal.value && (
                                <Form.Group className="mb-3" controlId="utgVersionAdditionalCondition">
                                    <Form.Check
                                        type="radio"
                                        className="mb-3"
                                        inline
                                        label="AND"
                                        name="andOrGroup"
                                        id="utgAnd"
                                        value="AND"
                                        checked={utgVersionMultiplePredicatesOperatorSignal.value === "AND"}
                                        onChange={(e) => utgVersionMultiplePredicatesOperatorSignal.value = e.target.value}
                                    />
                                    <Form.Check
                                        type="radio"
                                        className="mb-3"
                                        inline
                                        label="OR"
                                        name="andOrGroup"
                                        id="utgOr"
                                        value="OR"
                                        checked={utgVersionMultiplePredicatesOperatorSignal.value === "OR"}
                                        onChange={(e) => utgVersionMultiplePredicatesOperatorSignal.value = e.target.value}
                                    />
                                    <Form.Select className="mb-3" onInput={(e) => utgVersionAdditionalPredicateOperatorSignal.value = e.target.value} value={utgVersionAdditionalPredicateOperatorSignal.value == null ? "LIKE" : utgVersionAdditionalPredicateOperatorSignal.value}>
                                        <option value="LIKE">Is Equal To</option>
                                        <option value="NEQ">Is Not Equal To</option>
                                        <option value="LT">Is Less Than</option>
                                        <option value="LTE">Is Less Than or Equal To</option>
                                        <option value="GT">Is Greater Than</option>
                                        <option value="GTE">Is Greater Than or Equal To</option>
                                    </Form.Select>
                                    <Form.Control type="text" className="d-block" onChange={(event) => utgVersionAdditionalPredicateTextSignal.value = event.target.value} value={utgVersionAdditionalPredicateTextSignal.value} />
                                </Form.Group>
                            ))}

                            {/* Agent Version Filter */}
                            {(currentSelectedFilterSignal.value === "AgentVersion" && (
                                <Form.Group className="mb-3" controlId="agentVersion">
                                    <Form.Label className="d-block">Agent Version</Form.Label>
                                    <Form.Select className="mb-3" onInput={(e) => agentVersionOperatorSignal.value = e.target.value} value={agentVersionOperatorSignal.value == null ? "LIKE" : agentVersionOperatorSignal.value}>
                                        <option value="LIKE">Is Equal To</option>
                                        <option value="NEQ">Is Not Equal To</option>
                                        <option value="LT">Is Less Than</option>
                                        <option value="LTE">Is Less Than or Equal To</option>
                                        <option value="GT">Is Greater Than</option>
                                        <option value="GTE">Is Greater Than or Equal To</option>
                                    </Form.Select>
                                    <Form.Control type="text" className="d-block mb-3" onChange={(event) => agentVersionTextSignal.value = event.target.value} value={agentVersionTextSignal.value} />
                                    <Button onClick={() => agentVersionMultiplePredicatesSignal.value = true} hidden={agentVersionMultiplePredicatesSignal.value}>Add Condition</Button>
                                </Form.Group>
                            ))}

                            {/* Agent Version Filter Additional Condition */}
                            {(currentSelectedFilterSignal.value === "AgentVersion" && agentVersionMultiplePredicatesSignal.value && (
                                <Form.Group className="mb-3" controlId="agentVersionAdditionalCondition">
                                    <Form.Check
                                        type="radio"
                                        className="mb-3"
                                        inline
                                        label="AND"
                                        name="andOrGroup"
                                        id="utgAnd"
                                        value="AND"
                                        checked={agentVersionMultiplePredicatesOperatorSignal.value === "AND"}
                                        onChange={(e) => agentVersionMultiplePredicatesOperatorSignal.value = e.target.value}
                                    />
                                    <Form.Check
                                        type="radio"
                                        className="mb-3"
                                        inline
                                        label="OR"
                                        name="andOrGroup"
                                        id="utgOr"
                                        value="OR"
                                        checked={agentVersionMultiplePredicatesOperatorSignal.value === "OR"}
                                        onChange={(e) => agentVersionMultiplePredicatesOperatorSignal.value = e.target.value}
                                    />
                                    <Form.Select className="mb-3" onInput={(e) => agentVersionAdditionalPredicateOperatorSignal.value = e.target.value} value={agentVersionAdditionalPredicateOperatorSignal.value == null ? "LIKE" : agentVersionAdditionalPredicateOperatorSignal.value}>
                                        <option value="LIKE">Is Equal To</option>
                                        <option value="NEQ">Is Not Equal To</option>
                                        <option value="LT">Is Less Than</option>
                                        <option value="LTE">Is Less Than or Equal To</option>
                                        <option value="GT">Is Greater Than</option>
                                        <option value="GTE">Is Greater Than or Equal To</option>
                                    </Form.Select>
                                    <Form.Control type="text" className="d-block" onChange={(event) => agentVersionAdditionalPredicateTextSignal.value = event.target.value} value={agentVersionAdditionalPredicateTextSignal.value} />
                                </Form.Group>
                            ))}

                            {/* ComponentMerchant Filter */}
                            {(currentSelectedFilterSignal.value === "ComponentMerchant" && (
                                <Form.Group className="mb-3" controlId="componentMerchant">
                                    <Form.Label className="d-block">Merchant</Form.Label>
                                    <Form.Control type="text" className="d-block" onChange={(event) => merchantTextSignal.value = event.target.value} value={merchantTextSignal.value} />
                                </Form.Group>
                            ))}

                            {/* ComponentNickname Filter */}
                            {(currentSelectedFilterSignal.value === "ComponentNickname" && (
                                <Form.Group className="mb-3" controlId="componentNickname">
                                    <Form.Label className="d-block">UTG Nickname</Form.Label>
                                    <Form.Control type="text" className="d-block" onChange={(event) => utgNicknameTextSignal.value = event.target.value} value={utgNicknameTextSignal.value} />
                                </Form.Group>
                            ))}

                            {/* ComponentProfileName Filter */}
                            {(currentSelectedFilterSignal.value === "ComponentProfileName" && (
                                <Form.Group className="mb-3" controlId="componentProfileName">
                                    <Form.Label className="d-block">Profile</Form.Label>
                                    <Form.Control type="text" className="d-block" onChange={(event) => profileTextSignal.value = event.target.value} value={profileTextSignal.value} />
                                </Form.Group>
                            ))}

                            {/* ComponentProfileVersion Filter */}
                            {(currentSelectedFilterSignal.value === "ComponentProfileVersion" && (
                                <Form.Group className="mb-3" controlId="componentProfileVersion">
                                    <Form.Label className="d-block">Profile Version</Form.Label>
                                    <Form.Control
                                        type="number"
                                        step="1"
                                        className="d-block"
                                        onChange={(event) => {
                                            const val = event.target.value;
                                            if (/^\d*$/.test(val)) { // allows only empty or integer input
                                                profileVersionIntegerSignal.value = val;
                                            }
                                        }}
                                        value={profileVersionIntegerSignal.value} />
                                </Form.Group>
                            ))}

                            {/* ComponentLocation Filter */}
                            {(currentSelectedFilterSignal.value === "ComponentLocation" && (
                                <Form.Group className="mb-3" controlId="componentLocation">
                                    <Form.Label className="d-block">Location/Serial</Form.Label>
                                    <Form.Control type="text" className="d-block" onChange={(event) => locationTextSignal.value = event.target.value} value={locationTextSignal.value} />
                                </Form.Group>
                            ))}

                            {/* ComponentLane Filter */}
                            {(currentSelectedFilterSignal.value === "ComponentLane" && (
                                <Form.Group className="mb-3" controlId="componentLane">
                                    <Form.Label className="d-block">Lane</Form.Label>
                                    <Form.Control type="text" className="d-block" onChange={(event) => laneTextSignal.value = event.target.value} value={laneTextSignal.value} />
                                </Form.Group>
                            ))}

                            {/* ComponentFileId Filter */}
                            {(currentSelectedFilterSignal.value === "ComponentFileId" && (
                                <Form.Group className="mb-3" controlId="componentFileId">
                                    <Form.Label className="d-block">File ID</Form.Label>
                                    <Form.Control type="text" className="d-block" onChange={(event) => fileIdTextSignal.value = event.target.value} value={fileIdTextSignal.value} />
                                </Form.Group>
                            ))}

                            {/* MachineStatus Filter */}
                            {(currentSelectedFilterSignal.value === "MachineStatus" && (
                                <Form.Group className="mb-3" controlId="machineStatus">
                                    <Form.Label className="d-block">Machine Status</Form.Label>
                                    <Form.Control type="text" className="d-block" onChange={(event) => machineStatusTextSignal.value = event.target.value} value={machineStatusTextSignal.value} />
                                </Form.Group>
                            ))}

                            {/* UtgStatus Filter */}
                            {(currentSelectedFilterSignal.value === "UtgStatus" && (
                                <Form.Group className="mb-3" controlId="utgStatus">
                                    <Form.Label className="d-block">UTG Status</Form.Label>
                                    <Form.Control type="text" className="d-block" onChange={(event) => utgStatusTextSignal.value = event.target.value} value={utgStatusTextSignal.value} />
                                </Form.Group>
                            ))}

                            {/* DeviceStatusFirmwareVersion Filter */}
                            {(currentSelectedFilterSignal.value === "DeviceStatusFirmwareVersion" && (
                                <Form.Group className="mb-3" controlId="deviceStatusFirmwareVersion">
                                    <Form.Label className="d-block">Firmware Version</Form.Label>
                                    <Form.Select className="mb-3" onInput={(e) => firmwareVersionOperatorSignal.value = e.target.value} value={firmwareVersionOperatorSignal.value == null ? "LIKE" : firmwareVersionOperatorSignal.value}>
                                        <option value="LIKE">Is Equal To</option>
                                        <option value="NEQ">Is Not Equal To</option>
                                        <option value="LT">Is Less Than</option>
                                        <option value="LTE">Is Less Than or Equal To</option>
                                        <option value="GT">Is Greater Than</option>
                                        <option value="GTE">Is Greater Than or Equal To</option>
                                    </Form.Select>
                                    <Form.Control type="text" className="d-block mb-3" onChange={(event) => firmwareVersionTextSignal.value = event.target.value} value={firmwareVersionTextSignal.value} />
                                    <Button onClick={() => firmwareVersionMultiplePredicatesSignal.value = true} hidden={firmwareVersionMultiplePredicatesSignal.value}>Add Condition</Button>
                                </Form.Group>
                            ))}

                            {/* DeviceStatusFirmwareVersion Filter Additional Condition */}
                            {(currentSelectedFilterSignal.value === "DeviceStatusFirmwareVersion" && firmwareVersionMultiplePredicatesSignal.value && (
                                <Form.Group className="mb-3" controlId="deviceStatusFirmwareVersionAdditionalCondition">
                                    <Form.Check
                                        type="radio"
                                        className="mb-3"
                                        inline
                                        label="AND"
                                        name="andOrGroup"
                                        id="utgAnd"
                                        value="AND"
                                        checked={firmwareVersionMultiplePredicatesOperatorSignal.value === "AND"}
                                        onChange={(e) => firmwareVersionMultiplePredicatesOperatorSignal.value = e.target.value}
                                    />
                                    <Form.Check
                                        type="radio"
                                        className="mb-3"
                                        inline
                                        label="OR"
                                        name="andOrGroup"
                                        id="utgOr"
                                        value="OR"
                                        checked={firmwareVersionMultiplePredicatesOperatorSignal.value === "OR"}
                                        onChange={(e) => firmwareVersionMultiplePredicatesOperatorSignal.value = e.target.value}
                                    />
                                    <Form.Select className="mb-3" onInput={(e) => firmwareVersionAdditionalPredicateOperatorSignal.value = e.target.value} value={firmwareVersionAdditionalPredicateOperatorSignal.value == null ? "LIKE" : firmwareVersionAdditionalPredicateOperatorSignal.value}>
                                        <option value="LIKE">Is Equal To</option>
                                        <option value="NEQ">Is Not Equal To</option>
                                        <option value="LT">Is Less Than</option>
                                        <option value="LTE">Is Less Than or Equal To</option>
                                        <option value="GT">Is Greater Than</option>
                                        <option value="GTE">Is Greater Than or Equal To</option>
                                    </Form.Select>
                                    <Form.Control type="text" className="d-block" onChange={(event) => firmwareVersionAdditionalPredicateTextSignal.value = event.target.value} value={firmwareVersionAdditionalPredicateTextSignal.value} />
                                </Form.Group>
                            ))}

                            {/* DeviceStatusDevicePciVersion Filter */}
                            {(currentSelectedFilterSignal.value === "DeviceStatusDevicePciVersion" && (
                                <Form.Group className="mb-3" controlId="deviceStatusDevicePciVersion">
                                    <Form.Label className="d-block">PCI Version</Form.Label>
                                    <Form.Select className="mb-3" onInput={(e) => pciVersionOperatorSignal.value = e.target.value} value={pciVersionOperatorSignal.value == null ? "LIKE" : pciVersionOperatorSignal.value}>
                                        <option value="LIKE">Is Equal To</option>
                                        <option value="NEQ">Is Not Equal To</option>
                                        <option value="LT">Is Less Than</option>
                                        <option value="LTE">Is Less Than or Equal To</option>
                                        <option value="GT">Is Greater Than</option>
                                        <option value="GTE">Is Greater Than or Equal To</option>
                                    </Form.Select>
                                    <Form.Control type="text" className="d-block mb-3" onChange={(event) => pciVersionTextSignal.value = event.target.value} value={pciVersionTextSignal.value} />
                                    <Button onClick={() => pciVersionMultiplePredicatesSignal.value = true} hidden={pciVersionMultiplePredicatesSignal.value}>Add Condition</Button>
                                </Form.Group>
                            ))}

                            {/* DeviceStatusDevicePciVersion Filter Additional Condition */}
                            {(currentSelectedFilterSignal.value === "DeviceStatusDevicePciVersion" && pciVersionMultiplePredicatesSignal.value && (
                                <Form.Group className="mb-3" controlId="DeviceStatusDevicePciVersionAdditionalCondition">
                                    <Form.Check
                                        type="radio"
                                        className="mb-3"
                                        inline
                                        label="AND"
                                        name="andOrGroup"
                                        id="utgAnd"
                                        value="AND"
                                        checked={pciVersionMultiplePredicatesOperatorSignal.value === "AND"}
                                        onChange={(e) => pciVersionMultiplePredicatesOperatorSignal.value = e.target.value}
                                    />
                                    <Form.Check
                                        type="radio"
                                        className="mb-3"
                                        inline
                                        label="OR"
                                        name="andOrGroup"
                                        id="utgOr"
                                        value="OR"
                                        checked={pciVersionMultiplePredicatesOperatorSignal.value === "OR"}
                                        onChange={(e) => pciVersionMultiplePredicatesOperatorSignal.value = e.target.value}
                                    />
                                    <Form.Select className="mb-3" onInput={(e) => pciVersionAdditionalPredicateOperatorSignal.value = e.target.value} value={pciVersionAdditionalPredicateOperatorSignal.value == null ? "LIKE" : pciVersionAdditionalPredicateOperatorSignal.value}>
                                        <option value="LIKE">Is Equal To</option>
                                        <option value="NEQ">Is Not Equal To</option>
                                        <option value="LT">Is Less Than</option>
                                        <option value="LTE">Is Less Than or Equal To</option>
                                        <option value="GT">Is Greater Than</option>
                                        <option value="GTE">Is Greater Than or Equal To</option>
                                    </Form.Select>
                                    <Form.Control type="text" className="d-block mb-3" onChange={(event) => pciVersionAdditionalPredicateTextSignal.value = event.target.value} value={pciVersionAdditionalPredicateTextSignal.value} />
                                </Form.Group>
                            ))}

                            {/* DeviceConfigDeviceType Filter */}
                            {(currentSelectedFilterSignal.value === "DeviceConfigDeviceType" && (
                                <Form.Group className="mb-3" controlId="deviceConfigDeviceType">
                                    <Form.Label className="d-block">Device Type</Form.Label>
                                    <Form.Control type="text" className="d-block" onChange={(event) => deviceTypeTextSignal.value = event.target.value} value={deviceTypeTextSignal.value} />
                                </Form.Group>
                            ))}

                            {/* DeviceStatusDeviceSerialNumber Filter */}
                            {(currentSelectedFilterSignal.value === "DeviceStatusDeviceSerialNumber" && (
                                <Form.Group className="mb-3" controlId="deviceStatusDeviceSerialNumber">
                                    <Form.Label className="d-block">Device Serial</Form.Label>
                                    <Form.Control type="text" className="d-block" onChange={(event) => deviceSerialTextSignal.value = event.target.value} value={deviceSerialTextSignal.value} />
                                </Form.Group>
                            ))}

                            {/* DeviceConfigApiTerminalId Filter */}
                            {(currentSelectedFilterSignal.value === "DeviceConfigApiTerminalId" && (
                                <Form.Group className="mb-3" controlId="deviceConfigApiTerminalId">
                                    <Form.Label className="d-block">Terminal ID</Form.Label>
                                    <Form.Control type="text" className="d-block" onChange={(event) => terminalIdTextSignal.value = event.target.value} value={terminalIdTextSignal.value} />
                                </Form.Group>
                            ))}

                            {/* MachinePermanentId Filter */}
                            {(currentSelectedFilterSignal.value === "MachinePermanentId" && (
                                <Form.Group className="mb-3" controlId="machinePermanentId">
                                    <Form.Label className="d-block">Machine Permanent ID</Form.Label>
                                    <Form.Control
                                        type="text"
                                        className={`d-block ${machinePermanentIdErrorSignal.value ? 'is-invalid' : ''}`}
                                        onChange={(event) => {
                                            const value = event.target.value;
                                            machinePermanentIdTextSignal.value = value;
                                            machinePermanentIdErrorSignal.value = value && !isValidGuid(value);
                                        }}
                                        value={machinePermanentIdTextSignal.value}
                                    />
                                    {machinePermanentIdErrorSignal.value && (
                                        <Form.Text className="text-danger">Please enter a valid GUID.</Form.Text>
                                    )}
                                </Form.Group>
                            ))}

                            {/* ComponentPermanentId Filter */}
                            {(currentSelectedFilterSignal.value === "ComponentPermanentId" && (
                                <Form.Group className="mb-3" controlId="componentPermanentId">
                                    <Form.Label className="d-block">Component Permanent ID</Form.Label>
                                    <Form.Control
                                        type="text"
                                        className={`d-block ${componentPermanentIdErrorSignal.value ? 'is-invalid' : ''}`}
                                        onChange={(event) => {
                                            const value = event.target.value;
                                            componentPermanentIdTextSignal.value = value;
                                            componentPermanentIdErrorSignal.value = value && !isValidGuid(value);
                                        }}
                                        value={componentPermanentIdTextSignal.value}
                                    />
                                    {componentPermanentIdErrorSignal.value && (
                                        <Form.Text className="text-danger">Please enter a valid GUID.</Form.Text>
                                    )}
                                </Form.Group>
                            ))}

                            {/* TimeZone Filter */}
                            {(currentSelectedFilterSignal.value === "StandardTimeZone" && (
                                <Form.Group className="mb-3" controlId="standardTimeZone">
                                    <Form.Label className="d-block">Time Zone</Form.Label>
                                    <Form.Control type="text" className="d-block" onChange={(event) => standardTimeZoneTextSignal.value = event.target.value} value={standardTimeZoneTextSignal.value} />
                                </Form.Group>
                            ))}
                        </Form>
                    </Col>
                </Row>
            </Modal.Body>


            <Modal.Footer>
                <Button variant="secondary" onClick={handleCancel}>Cancel</Button>
                <Button variant="secondary" onClick={handleResetFilters}>Reset</Button>
                <Button
                    variant="primary"
                    disabled={machinePermanentIdErrorSignal.value || componentPermanentIdErrorSignal.value}
                    onClick={handleBuildPredicatesObject}><Icon icon='book' width="16" height="16"></Icon>&nbsp;
                    Apply
                </Button>
            </Modal.Footer>

        </Modal>
    );
}

export default DevicesListFilteringModal;
